if (!customElements.get('glassify-newsletter-signup')) {
  customElements.define('glassify-newsletter-signup', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      if (!this.form || !this.button) return;

      this.originalText = this.button.textContent;
      this.originalDisabled = this.button.disabled;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.form.addEventListener('submit', (event) => {
        if (this.pending) {
          event.preventDefault();
          return;
        }

        // Let Shopify's validation and challenge handlers cancel first.
        queueMicrotask(() => {
          if (event.defaultPrevented || !this.isConnected) return;

          this.pending = true;
          this.form.setAttribute('aria-busy', 'true');
          this.button.disabled = true;
          this.button.textContent = this.button.dataset.submittingText || this.originalText;

          // Allow retry if navigation is interrupted without a page response.
          this.resetTimer = window.setTimeout(() => this.reset(), 15000);
        });
      }, options);

      window.addEventListener('pageshow', () => this.reset(), options);
      window.addEventListener('pagehide', () => this.reset(), options);
    }

    reset() {
      window.clearTimeout(this.resetTimer);
      this.pending = false;
      this.form?.removeAttribute('aria-busy');
      if (this.button) {
        this.button.disabled = this.originalDisabled;
        this.button.textContent = this.originalText;
      }
    }

    disconnectedCallback() {
      this.reset();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
